import template from './auth-last-step.jade';

export default {
  template,
  controller: function ($q, analyticsService, addFormService) {
    'ngInject';

    analyticsService.authLastStepShow(addFormService.ad.isByHomeowner);

    this.showRemindPasswordForm = false;
    this.emailForRemindPasswordForm = null;

    this.onRemindPassword = email => {
      this.showRemindPasswordForm = true;
      this.emailForRemindPasswordForm = email;
    };

    this.cancelRemindPassword = () => {
      this.showRemindPasswordForm = false;
      this.emailForRemindPasswordForm = null;
    };

    // Шаринг данных через общий родительский компонент
    // Используется для соц регистрации
    this.mergeData = {
      visible: false,
    };
    this.enterEmailData = {
      visible: false,
    };
    this.submitting = false;
    this.socialSubmitting = false;
  },
};
